module.exports = __webpack_public_path__ + "media/images/DSC_3467-a70b5574c7143b8593e852c048595360.jpg";